import { Component, OnInit, OnDestroy, ViewChild, EventEmitter, Output, Input, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApplicantService } from '../applicant-service/applicant.service';
import { ResumeParsingStatusModel } from '../applicant-service/service-models/ResumeParsingStatusModel';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-resume-parsing-state',
  templateUrl: './resume-parsing-state.component.html',
  styleUrls: ['./resume-parsing-state.component.scss']
})
export class ResumeParsingStateComponent implements AfterViewInit, OnInit, OnDestroy {
  private pollingIntervalInMilliseconds = 500;
  private pollingCount = 0;
  private pollingLimit = 20;
  private errorCount = 0;
  private errorLimit = 10;
  private subscription = new Subscription();

  @Output()
  parsingCompleted = new EventEmitter();
  @Input()
  initialParsingState: ResumeParsingStatusModel;
  isParsingPending = true;
  hasParsingFailed = false;
  @ViewChild('modal')
  modal: ModalDirective;
  
  constructor(private applicantService: ApplicantService) { }

  ngAfterViewInit(): void {
    this.modal.config = this.modal.config || { backdrop: 'static' };
  }

  ngOnInit(): void {
    if (this.initialParsingState.resumeWasUploaded &&
      (this.initialParsingState.state === 'NotStarted' || this.initialParsingState.state === 'Pending')) { this.checkStatus(this); }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkStatus(context: any) {
    context.pollingCount++;
    const sub = context.applicantService.getResumeParsingState(+localStorage.getItem('applicationId'))
      .subscribe((data: ResumeParsingStatusModel) => {
        if (['Succeeded', 'Failed', 'Cancelled'].indexOf(data.state) > -1) {
          context.isParsingPending = false;
          context.hasParsingFailed = data.state === 'Failed';
          this.parsingCompleted.emit(data);
        } else {
          if (context.pollingCount < context.pollingLimit) {
            setTimeout(() => {
                context.checkStatus(context);
              },
              context.pollingIntervalInMilliseconds);
          } else {
            context.isParsingPending = false;
            context.hasParsingFailed = true;
            this.parsingCompleted.emit(data);
          }
        }
        context.updateModal();
      }, error => {
        context.errorCount++;
        if (context.errorCount < context.errorLimit) {
          setTimeout(() => {
            context.checkStatus(context);
          }, context.pollingIntervalInMilliseconds);
        }
      });

    context.subscription.add(sub);
  }

  skipResumeParsing() {
    const sub = this.applicantService.skipResumeParsing(+localStorage.getItem('applicationId'))
      .subscribe(() => {
        const data: ResumeParsingStatusModel = new ResumeParsingStatusModel();

        this.modal.hide();
        data.state = 'Cancelled';
        this.parsingCompleted.emit(data);
      }, error => {
        
      });

    this.subscription.add(sub);
  }

  private updateModal(): void {
    if (!this.modal) {
      return;
    }

    const shouldShowModal = this.isParsingPending || this.hasParsingFailed;
    if (this.modal.isShown && !shouldShowModal) {
      this.modal.hide();
    } else if (!this.modal.isShown && shouldShowModal) {
      this.modal.show();
    }
  }
}
